import { render } from "./cdrBatchManagement.vue?vue&type=template&id=46bc5c18&scoped=true"
import script from "./cdrBatchManagement.vue?vue&type=script&lang=js"
export * from "./cdrBatchManagement.vue?vue&type=script&lang=js"

import "./cdrBatchManagement.vue?vue&type=style&index=0&id=46bc5c18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46bc5c18"

export default script